var exports = {
  "nd": "TableGamePanel.module__panel___RWtmN1",
  "tp": "TableGamePanel.module__table___RWtmN1",
  "wx": "TableGamePanel.module__header___RWtmN1",
  "DD": "TableGamePanel.module__title___RWtmN1",
  "aX": "TableGamePanel.module__back___RWtmN1",
  "xq": "TableGamePanel.module__slotList___RWtmN1",
  "V9": "TableGamePanel.module__slotRow___RWtmN1",
  "M8": "TableGamePanel.module__slotName___RWtmN1",
  "pZ": "TableGamePanel.module__slotGame___RWtmN1",
  "gi": "TableGamePanel.module__slotState___RWtmN1",
};

module.exports = exports;
